import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgInstagram({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 5.7v12.6a2.7 2.7 0 01-2.7 2.7H5.7A2.7 2.7 0 013 18.3V5.7A2.7 2.7 0 015.7 3h12.6A2.7 2.7 0 0121 5.7zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm6-4a1 1 0 100 2 1 1 0 000-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgInstagram
